import React, { useState } from 'react'
import { useParams } from 'react-router-dom';

export default function CasinoExtendedList() {
    const { id, sub } = useParams();
    const [casinoCategory, setCasinoCategory] = useState( [
        {
          gmid: 35,
          gname: "All Casino",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 31,
          gname: "Roulette",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 20,
          gname: "Teenpatti",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 21,
          gname: "Poker",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 22,
          gname: "Baccarat",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 23,
          gname: "Dragon Tiger",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 24,
          gname: "32 Cards",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 26,
          gname: "Andar Bahar",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 27,
          gname: "Lucky 7",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 28,
          gname: "3 Card Judgement",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 29,
          gname: "Casino War",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 30,
          gname: "Worli",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 34,
          gname: "Sports",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 32,
          gname: "Bollywood",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 33,
          gname: "Lottery",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 40,
          gname: "Queen",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 41,
          gname: "Race",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        },
        {
          gmid: 73,
          gname: "Others",
          tabno: 6,
          cname: "Our Casino",
          gameid: 0
        }
      ]);
      const [casinoList, setCasinoList] = useState([
        {
          cid: 4,
          gid: 35,
          gmid: "worli3",
          gname: "Matka",
          gtid: 0,
          imgpath: "worli3.gif",
          srno: 792,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen62",
          gname: "V VIP Teenpatti 1-day",
          gtid: 0,
          imgpath: "teen62.gif",
          srno: 793,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "dolidana",
          gname: "Dolidana",
          gtid: 0,
          imgpath: "dolidana.gif",
          srno: 794,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "mogambo",
          gname: "Mogambo",
          gtid: 0,
          imgpath: "mogambo.gif",
          srno: 795,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen20v1",
          gname: "20-20 Teenpatti VIP1",
          gtid: 0,
          imgpath: "teen20v1.jpg",
          srno: 796,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "lucky5",
          gname: "Lucky 6",
          gtid: 0,
          imgpath: "lucky5.jpg",
          srno: 797,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "roulette12",
          gname: "Beach Roulette",
          gtid: 0,
          imgpath: "roulette12.jpg",
          srno: 798,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "roulette13",
          gname: "Roulette",
          gtid: 0,
          imgpath: "roulette13.jpg",
          srno: 799,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "roulette11",
          gname: "Golden Roulette",
          gtid: 0,
          imgpath: "roulette11.jpg",
          srno: 800,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "poison",
          gname: "Teenpatti Poison One Day",
          gtid: 0,
          imgpath: "poison.jpg",
          srno: 801,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teenunique",
          gname: "Unique Teenpatti",
          gtid: 0,
          imgpath: "teenunique.jpg",
          srno: 802,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "poison20",
          gname: "Teenpatti Poison 20-20",
          gtid: 0,
          imgpath: "poison20.jpg",
          srno: 803,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "joker120",
          gname: "Unlimited Joker 20-20",
          gtid: 0,
          imgpath: "joker120.jpg",
          srno: 804,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "joker20",
          gname: "Teenpatti Joker 20-20",
          gtid: 0,
          imgpath: "joker20.jpg",
          srno: 805,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "joker1",
          gname: "Unlimited Joker Oneday",
          gtid: 0,
          imgpath: "joker1.jpg",
          srno: 806,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen20c",
          gname: "20-20 Teenpatti C",
          gtid: 0,
          imgpath: "teen20c.jpg",
          srno: 808,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "btable2",
          gname: "Bollywood Casino 2",
          gtid: 0,
          imgpath: "btable2.jpg",
          srno: 809,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "ourroullete",
          gname: "Unique Roulette",
          gtid: 0,
          imgpath: "ourroullete.jpg",
          srno: 810,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "superover3",
          gname: "Mini Superover",
          gtid: 0,
          imgpath: "superover3.jpg",
          srno: 811,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "goal",
          gname: "Goal",
          gtid: 0,
          imgpath: "goal.jpg",
          srno: 812,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "ab4",
          gname: "ANDAR BAHAR 150 cards",
          gtid: 0,
          imgpath: "ab4.jpg",
          srno: 813,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "lucky15",
          gname: "Lucky 15",
          gtid: 0,
          imgpath: "lucky15.jpg",
          srno: 814,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "superover2",
          gname: "Super Over2",
          gtid: 0,
          imgpath: "superover2.jpg",
          srno: 815,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen41",
          gname: "Queen Top Open Teenpatti",
          gtid: 0,
          imgpath: "teen41.jpg",
          srno: 816,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen42",
          gname: "Jack Top Open Teenpatti",
          gtid: 0,
          imgpath: "teen42.jpg",
          srno: 817,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "sicbo2",
          gname: "Sic Bo2",
          gtid: 0,
          imgpath: "sicbo2.jpg",
          srno: 819,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen33",
          gname: "Instant Teenpatti 3.0",
          gtid: 0,
          imgpath: "teen33.jpg",
          srno: 822,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "sicbo",
          gname: "Sic Bo",
          gtid: 0,
          imgpath: "sicbo.jpg",
          srno: 823,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "ballbyball",
          gname: "Ball by Ball",
          gtid: 0,
          imgpath: "ballbyball.jpg",
          srno: 824,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen32",
          gname: "Instant Teenpatti 2.0",
          gtid: 0,
          imgpath: "teen32.jpg",
          srno: 825,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen",
          gname: "Teenpatti 1-day",
          gtid: 0,
          imgpath: "teen.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen20",
          gname: "20-20 Teenpatti",
          gtid: 0,
          imgpath: "teen20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen9",
          gname: "Teenpatti Test",
          gtid: 0,
          imgpath: "teen9.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen8",
          gname: "Teenpatti Open",
          gtid: 0,
          imgpath: "teen8.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "poker",
          gname: "Poker 1-Day",
          gtid: 0,
          imgpath: "poker.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "poker20",
          gname: "20-20 Poker",
          gtid: 0,
          imgpath: "poker20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "poker6",
          gname: "Poker 6 Players",
          gtid: 0,
          imgpath: "poker6.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "baccarat",
          gname: "Baccarat",
          gtid: 0,
          imgpath: "baccarat.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "baccarat2",
          gname: "Baccarat 2",
          gtid: 0,
          imgpath: "baccarat2.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "dt20",
          gname: "20-20 Dragon Tiger",
          gtid: 0,
          imgpath: "dt20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "dt6",
          gname: "1 Day Dragon Tiger",
          gtid: 0,
          imgpath: "dt6.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "dtl20",
          gname: "20-20 D T L",
          gtid: 0,
          imgpath: "dtl20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "dt202",
          gname: "20-20 Dragon Tiger 2",
          gtid: 0,
          imgpath: "dt202.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "card32",
          gname: "32 Cards A",
          gtid: 0,
          imgpath: "card32.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "card32eu",
          gname: "32 Cards B",
          gtid: 0,
          imgpath: "card32eu.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "ab20",
          gname: "Andar Bahar",
          gtid: 0,
          imgpath: "ab20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "abj",
          gname: "Andar Bahar 2",
          gtid: 0,
          imgpath: "abj.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "lucky7",
          gname: "Lucky 7 - A",
          gtid: 0,
          imgpath: "lucky7.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "lucky7eu",
          gname: "Lucky 7 - B",
          gtid: 0,
          imgpath: "lucky7eu.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "3cardj",
          gname: "3 Cards Judgement",
          gtid: 0,
          imgpath: "3cardj.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "war",
          gname: "Casino War",
          gtid: 0,
          imgpath: "war.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "worli",
          gname: "Worli Matka",
          gtid: 0,
          imgpath: "worli.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "worli2",
          gname: "Instant Worli",
          gtid: 0,
          imgpath: "worli2.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "aaa",
          gname: "Amar Akbar Anthony",
          gtid: 0,
          imgpath: "aaa.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "btable",
          gname: "Bollywood Casino",
          gtid: 0,
          imgpath: "btable.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "lottcard",
          gname: "Lottery",
          gtid: 0,
          imgpath: "lottcard.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "cricketv3",
          gname: "5Five Cricket",
          gtid: 0,
          imgpath: "cricketv3.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "cmatch20",
          gname: "Cricket Match 20-20",
          gtid: 0,
          imgpath: "cmatch20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "cmeter",
          gname: "Casino Meter",
          gtid: 0,
          imgpath: "cmeter.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen6",
          gname: "Teenpatti - 2.0",
          gtid: 0,
          imgpath: "teen6.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "queen",
          gname: "Queen",
          gtid: 0,
          imgpath: "queen.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "race20",
          gname: "Race20",
          gtid: 0,
          imgpath: "race20.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "lucky7eu2",
          gname: "Lucky 7 - C",
          gtid: 0,
          imgpath: "lucky7eu2.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "superover",
          gname: "Super Over",
          gtid: 0,
          imgpath: "superover.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "trap",
          gname: "The Trap",
          gtid: 0,
          imgpath: "trap.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "patti2",
          gname: "2 Cards Teenpatti",
          gtid: 0,
          imgpath: "patti2.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teensin",
          gname: "29Card Baccarat",
          gtid: 0,
          imgpath: "teensin.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teenmuf",
          gname: "Muflis Teenpatti",
          gtid: 0,
          imgpath: "teenmuf.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "race17",
          gname: "Race To 17",
          gtid: 0,
          imgpath: "race17.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen20b",
          gname: "20-20 Teenpatti B",
          gtid: 0,
          imgpath: "teen20b.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "trio",
          gname: "Trio",
          gtid: 0,
          imgpath: "trio.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "notenum",
          gname: "Note Number",
          gtid: 0,
          imgpath: "notenum.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "kbc",
          gname: "K.B.C",
          gtid: 0,
          imgpath: "kbc.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen120",
          gname: "1 CARD 20-20",
          gtid: 0,
          imgpath: "teen120.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen1",
          gname: "1 CARD ONE-DAY",
          gtid: 0,
          imgpath: "teen1.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "ab3",
          gname: "ANDAR BAHAR 50 cards",
          gtid: 0,
          imgpath: "ab3.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "aaa2",
          gname: "Amar Akbar Anthony 2",
          gtid: 0,
          imgpath: "aaa2.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "race2",
          gname: "Race to 2nd",
          gtid: 0,
          imgpath: "race2.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "teen3",
          gname: "Instant Teenpatti",
          gtid: 0,
          imgpath: "teen3.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "dum10",
          gname: "Dus ka Dum",
          gtid: 0,
          imgpath: "dum10.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        },
        {
          cid: 4,
          gid: 35,
          gmid: "cmeter1",
          gname: "1 Card Meter",
          gtid: 0,
          imgpath: "cmeter1.jpg",
          srno: 998,
          tabno: 6,
          isframe: 0,
          tid: 0
        }
      ]);
  return (
    <div className="center-main-container list-page own-casino-page">
    <div className="center-container">
      <div className="container-fluid container-fluid-5">
        <div className="row row5">
          <div className="col-xl-2 d-none d-xl-flex">
            <ul className="nav nav-pills casino-sub-tab">
              
              {casinoCategory.map((category) => (
                <li className="nav-item">
                  <a className="nav-link " href={`/casino-list/LC/${id}/${category.gmid}`}>
                    <span>{category.gname}</span>
                  </a>
                </li>
              ))}
            
            </ul>
          </div>
          <div className="col-xl-10 col-12">
            <div className="casino-tab-list d-xl-none">
              <ul className="nav nav-pills casino-tab" id="casino-tab">
                <li className="nav-item">
                  <a className="nav-link active" href="/casino-list/LC/4">
                    <span>Our Casino</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link " href="/casino-list/LC/45">
                    <span>Our VIP Casino</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link " href="/casino-list/LC/52">
                    <span>Our Premium Casino</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link " href="/casino-list/LC/19">
                    <span>Our Virtual</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link " href="/casino-list/LC/53">
                    <span>Tembo</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="casino-sub-tab-list d-xl-none">
              <ul className="nav nav-pills casino-sub-tab" id="casino-sub-tab">
                {casinoCategory.map((category) => (
                  <li className="nav-item">
                    <a className="nav-link " href={`/casino-list/LC/${id}/${category.gmid}`}>
                    <span>{category.gname}</span>
                  </a>
                </li>
                ))}
               
              </ul>
            </div>
            <div className="tab-content">
              <div className="tab-pane active" id="all-casino">
                <div className="casino-list">
                  {casinoList?.map((game) => (
                    <div key={game.gmid} className="casino-list-item">
                      <a href={`/casino/${game.gmid}`}>
                        <div className="casino-list-item-banner" style={{ backgroundImage: `url("https://dataobj.ecoassetsservice.com/casino-icons/lc/${game.imgpath}"), url("https://dataobj.ecoassetsservice.com/casino-icons/default.jpg")` }} />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="slot-iframe">
        <div className="slot-header">
          <div className="title">
            <h4 />
          </div>
        </div>
        <iframe
          src=""
          style={{ width: "100%", border: 0, background: "rgb(0, 0, 0)" }}
        />
      </div>
    </div>
  </div>
  
  )
}
